// extracted by mini-css-extract-plugin
export default {"section":"FeedbackView_section__pia+f","stars":"FeedbackView_stars__6e7HR","text-area":"FeedbackView_text-area__0r2fn","modalButtons":"FeedbackView_modalButtons__q8UVl"};